export type MaxHeight =
  | '0px'
  | '1px'
  | '2px'
  | '4px'
  | '6px'
  | '8px'
  | '10px'
  | '12px'
  | '14px'
  | '16px'
  | '20px'
  | '24px'
  | '28px'
  | '32px'
  | '36px'
  | '40px'
  | '44px'
  | '48px'
  | '56px'
  | '64px'
  | '80px'
  | '96px'
  | '112px'
  | '128px'
  | '144px'
  | '160px'
  | '176px'
  | '192px'
  | '208px'
  | '224px'
  | '240px'
  | '256px'
  | '288px'
  | '320px'
  | '384px'
  | 'min'
  | 'max'
  | 'fit';

export const maxHeightVariants: Record<MaxHeight, string> = {
  '0px': 'max-h-0',
  '1px': 'max-h-px',
  '2px': 'max-h-0.5',
  '4px': 'max-h-1',
  '6px': 'max-h-1.5',
  '8px': 'max-h-2',
  '10px': 'max-h-2.5',
  '12px': 'max-h-3',
  '14px': 'max-h-3.5',
  '16px': 'max-h-4',
  '20px': 'max-h-5',
  '24px': 'max-h-6',
  '28px': 'max-h-7',
  '32px': 'max-h-8',
  '36px': 'max-h-9',
  '40px': 'max-h-10',
  '44px': 'max-h-11',
  '48px': 'max-h-12',
  '56px': 'max-h-14',
  '64px': 'max-h-16',
  '80px': 'max-h-20',
  '96px': 'max-h-24',
  '112px': 'max-h-28',
  '128px': 'max-h-32',
  '144px': 'max-h-36',
  '160px': 'max-h-40',
  '176px': 'max-h-44',
  '192px': 'max-h-48',
  '208px': 'max-h-52',
  '224px': 'max-h-56',
  '240px': 'max-h-60',
  '256px': 'max-h-64',
  '288px': 'max-h-72',
  '320px': 'max-h-80',
  '384px': 'max-h-96',
  min: 'max-h-min',
  max: 'max-h-max',
  fit: 'max-h-fit',
};
